var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MyConfigurations = (function (MyConfigurations) {

        MyConfigurations.Messages = (function (Messages) {

            Messages.GetModel = function () {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.MyConfigurations.Messages.GetModel', null);
            };
            Messages.GetModel.className = 'Vendd.MyConfigurations.Messages.GetModel';

            Messages.GetModelFailed = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.MyConfigurations.Messages.GetModelFailed', response);
            };
            Messages.GetModelFailed.className = 'Vendd.MyConfigurations.Messages.GetModelFailed';

            Messages.GetModelSuccess = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.MyConfigurations.Messages.GetModelSuccess', response);
            };
            Messages.GetModelSuccess.className = 'Vendd.MyConfigurations.Messages.GetModelSuccess';



            Messages.Remove = function (Id) {
                var data = {
                    Id: Id
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.MyConfigurations.Messages.Remove', data);
            };
            Messages.Remove.className = 'Vendd.MyConfigurations.Messages.Remove';

            Messages.RemoveSuccess = function (Id) {
                var data = {
                    Id: Id
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.MyConfigurations.Messages.RemoveSuccess', Id);
            };
            Messages.RemoveSuccess.className = 'Vendd.MyConfigurations.Messages.RemoveSuccess';

            Messages.RemoveFailed = function (model) {
                var data = {
                    Id: Id
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.MyConfigurations.Messages.RemoveFailed', data);
            };
            Messages.RemoveFailed.className = 'Vendd.MyConfigurations.Messages.RemoveFailed';



            Messages.ConfirmInventory = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.MyConfigurations.Messages.ConfirmInventory');
            };
            Messages.ConfirmInventory.className = 'Vendd.MyConfigurations.Messages.ConfirmInventory';

            Messages.ConfirmInventorySuccess = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.MyConfigurations.Messages.ConfirmInventorySuccess');
            };
            Messages.ConfirmInventorySuccess.className = 'Vendd.MyConfigurations.Messages.ConfirmInventorySuccess';

            Messages.ConfirmInventoryFailed = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.MyConfigurations.Messages.ConfirmInventoryFailed');
            };
            Messages.ConfirmInventoryFailed.className = 'Vendd.MyConfigurations.Messages.ConfirmInventoryFailed';

            return Messages;

        })(MyConfigurations.Messages || {});

        return MyConfigurations;

    })(Vendd.MyConfigurations || {});

    return Vendd;

})(Vendd || {});